import { createSelector, createReducer } from '@reduxjs/toolkit';
import { COMMENTTYPE_INCLUDE } from '../../constants/api';
import {
  getAllCommentsForHearingSuccess,
  getAllHearingsSuccess,
  getPaginatedCommentsForHearingSuccess,
  getPaginatedHearingsSuccess,
} from '../actions/api';
import { getAttr, getEntityId, getRelId } from '../helpers/apiHelpers';
import { updateDtoList } from '../helpers/reducerHelpers';

import {
  getIncludedData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';
import { commentByIdSelector } from './commentSlice';

// -------- Overview --------

// CommentType is included in the following endpoints
//  - GET /hearing/{hearingId}/comment

// -------- Reducer --------
const commentTypeReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getAllCommentsForHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const commentTypes = data.filter(
          (include) => include.type === COMMENTTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', commentTypes);
      })
      .addCase(getPaginatedCommentsForHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const commentTypes = data.filter(
          (include) => include.type === COMMENTTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', commentTypes);
      });
    builder.addCase(getAllHearingsSuccess, (state, action) => {
      const data = getIncludedData(action);
      const commentTypes = data.filter(
        (include) => include.type === COMMENTTYPE_INCLUDE,
      );
      return updateDtoList(state, 'all', commentTypes);
    });
    builder.addCase(getPaginatedHearingsSuccess, (state, action) => {
      const data = getIncludedData(action);
      const commentTypes = data.filter(
        (include) => include.type === COMMENTTYPE_INCLUDE,
      );
      return updateDtoList(state, 'all', commentTypes);
    });
  },
);

// -------- Selectors --------
const selectGetAllCommentType = (state) =>
  selectAllFromApiState(state, 'commentType');
const allCommentTypeSelector = createSelector(
  selectGetAllCommentType,
  (commentType) => commentType,
);
const commentTypeByTypeSelector = (commentTypeType) =>
  createSelector(allCommentTypeSelector, (commentTypes) =>
    commentTypes.find(
      (commentType) => getAttr(commentType, 'commentType') === commentTypeType,
    ),
  );

const commentTypeByCommentIdSelector = (commentId) =>
  createSelector(
    [allCommentTypeSelector, commentByIdSelector(commentId)],
    (commentTypes, comment) =>
      commentTypes.find(
        (commentType) =>
          getEntityId(commentType) === getRelId(comment, 'commentType'),
      ),
  );

// -------- Exporting --------
export {
  allCommentTypeSelector,
  commentTypeByTypeSelector,
  commentTypeByCommentIdSelector,
};
export default commentTypeReducer;
